import { createStore, applyMiddleware } from 'redux';
import { createLogger } from 'redux-logger';
import { routerMiddleware } from 'react-router-redux';
import createSagaMiddleware from 'redux-saga';
import * as Sentry from '@sentry/react';

import rootReducer from './reducers';
import { loadState } from './localStorage';
import Sagas from './sagas';

const loggerMiddleware = createLogger();
const persistedState = loadState();

const sagaMiddleware = createSagaMiddleware({
  onError(error) {
    Sentry.captureException(error);
  },
});

export default function configureStore(history) {
  let store;

  if (process.env.NODE_ENV !== 'development') {
    const middleware = [sagaMiddleware, routerMiddleware(history)];

    store = createStore(rootReducer, persistedState, applyMiddleware(...middleware));
  } else {
    const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;

    const middleware = [loggerMiddleware, sagaMiddleware, routerMiddleware(history)];

    const enhancer = composeEnhancers(applyMiddleware(...middleware));

    store = createStore(
      rootReducer,
      persistedState,
      // applyMiddleware(...middleware),
      enhancer,
      window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__(),
    );
  }

  sagaMiddleware.run(Sagas, store.dispatch);

  return store;
}



// WEBPACK FOOTER //
// ./src/root/configureStore.js